import { Spiner } from "@components/loaders/spiner";
import { FinanceService } from "@services/finance.service";
import { usePageHeader } from "@hooks/use_page_header";
import { useQuery } from "@tanstack/react-query";
import { useStudentBio } from "@hooks/use_student_bio";
import { toRp } from "@utils/helper";
import moment from "moment-timezone";
import { LuInbox } from "react-icons/lu";
moment.locale("id");

export const MonthlyBillPage = () => {
  usePageHeader("Tagihan Bulanan", { bottomNavigation: "hidden" });

  const { nis } = useStudentBio();

  const { data, isPending } = useQuery({
    queryKey: [FinanceService.queries.GET_FINANCE_BILLS_PAID_OF, nis],
    queryFn: () => FinanceService.billsPaidOf({ nis }),
  });


  return (
    <>
      <div className="tw-px-4 tw-pt-2 tw-pb-20">
        {isPending ? (
          <div className="tw-text-center card-body">
            <Spiner />
          </div>
        ) : (
          <>
            {data?.data?.filter((item) => item.tipe?.toLowerCase().includes("spp")) != null &&
            data.data?.filter((item) => item.tipe?.toLowerCase().includes("spp")).length > 0 &&
            data?.data.filter((item) => item.tipe?.toLowerCase().includes("spp")) ? (
              <>
                {data?.data
                  .filter((item) => item.tipe?.toLowerCase().includes("spp"))
                  .map((item, idx) => (
                    <div className="tw-mb-4 tw-py-4 card-body" key={idx}>
                      <div className="tw-mb-1 tw-flex tw-justify-between tw-items-center tw-font-semibold">
                        <div className="tw-text-[10px] tw-font-medium tw-text-text-secondary">
                          tagihan
                        </div>
                      </div>
                      <div className="tw-flex tw-justify-between tw-items-end tw-font-semibold tw-text-text-primary">
                        <div
                          className="tw-text-sm"
                          style={{
                            overflowWrap: "break-word",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            maxWidth: "50%",
                          }}
                        >
                          {item.tagihan}
                        </div>
                        <div className="tw-w-1/2 tw-text-end">
                          <div className="tw-text-base tw-text-text-primary">
                            {toRp(item.nominal)}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
              </>
            ) : (
              <div className="tw-p-8 tw-text-center card-body">
                <LuInbox className="tw-mx-auto tw-mb-2 tw-text-5xl tw-text-text-secondary tw-opacity-40" />
                <div>Tidak ada tagihan</div>
              </div>
            )}
          </>
        )}
      </div>
    </>
  );
};
